import React from "react";
import Moment from "react-moment";
import { Box, Grid, Typography } from "@material-ui/core";

interface Props {
  field: string;
  value: any;
  isDateField?: boolean;
  asHtml?: boolean;
}

export const CardItem = ({ field, value, isDateField = false, asHtml }: Props) => {
  const changesTo = () => {
    if (asHtml) {
      return (
        <Typography
          dangerouslySetInnerHTML={{
            __html: value,
          }}
        ></Typography>
      );
    } else {
      return (
        <Typography>
          <Moment local={true} format="MM/DD/YYYY hh:mm A" date={value} />
        </Typography>
      );
    }
  };
  return (
    <Grid container item direction="row" xs={12} md={6}>
      <Grid item xs={4} md={4}>
        <Box color="text.secondary">
          <Typography>{`${field}: `}</Typography>
        </Box>
      </Grid>
      <Grid item xs={8} md={8}>
        <Box color="text.primary">
          {(isDateField || asHtml) && Boolean(value) ? (
            changesTo()
          ) : (
            <Typography>{value}</Typography>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};
